$ = jQuery.noConflict();


if (!jQuery) jQuery = $;


$(window).on('load', function() {
  'use strict';
});

$(document).ready(function() {



  // fetch json from medium RSS and populate slick carousel with posts.



  // update userame to valuate one once provided / has posts on page
  // var medium_username = "patientspurpose";
  var medium_username = 'valuatehealth';
  var medium_url = 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@' + medium_username;

  $.ajax({url: medium_url}).done(function(data) {
    var items = data.items;
    var articleCards = [];
    var colorClass = ['y-bg', 'b-bg', 'p-bg'];


    for (var i = 0; i < items.length; i++) {
      var element = items[i];
      var title = element.title;
      var formatDate = formateBlogDate(element.pubDate);
      var linkToArticle = element.link;


      var HTMLblock = [
        '<div class="col-md-12 blog-slider-item ' + colorClass[i % colorClass.length] + '">',
        '<a href=' + linkToArticle + ' target="_blank">',
        '<div class="slick-block-inner">',
        '<div class="slick-blog-date">',
        formatDate,
        '</div>',
        '<div class="slick-blog-title">',
        title,
        '</div>',
        // '<div class="svg-wrapper" style="max-width: 40px;">',
        '<svg id="icon-medium-white" viewBox="0 0 34.87 30.32">',
        '<title>icon-medium-white</title>',
        '<path d="M34.62 5.62L23.57 0a.37.37 0 0 0-.16 0 .4.4 0 0 0-.34.19l-6.82 11.17 7.6 12.48L34.72 6a.27.27 0 0 0-.1-.38zM12.65 19.48l10.6 5.35-10.6-17.39v12.04zM24.17 25.29l9.73 4.92a.62.62 0 0 0 1-.6V7.73zM11.48 5.68L1.29.53.64.2A.58.58 0 0 0 .38.13a.35.35 0 0 0-.27.13A.53.53 0 0 0 0 .6v23.5a1.29 1.29 0 0 0 .64 1.05l10 5.06a.87.87 0 0 0 .39.1.61.61 0 0 0 .57-.71V5.91a.26.26 0 0 0-.12-.23z" fill="#fff"></path>',
        '</svg>',
        // '</div>',
        '</div>',
        '</a>',
        '</div>',
      ];

      articleCards.push(HTMLblock.join(''));
    }


    $('.blog-slider').html(articleCards.join(''));
    $('.blog-slider').slick({
        // "setting-name": "setting-value"
        // infinite: true,
      dots: true,
      arrows: true,
      centerPadding: '40px',
      slidesToShow: 3,
      slidesToScroll: 3,
      speed: 1000,
      infinite: false,
      responsive: [{
        breakpoint: 1078,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true
        }
      },
        ]
    });


  });

});


function formateBlogDate(d) {
  var dateInit = d.split(' ');
  var YYMMDD = dateInit[0].split('-');
  var YY = YYMMDD.shift();
  YYMMDD.push(YY);
  return YYMMDD.join('.');
}


jQuery(function($) {


  'use strict';

  function Utils() {

  }

  Utils.prototype = {
    constructor: Utils,
    isElementInView: function(element, fullyInView) {
      var pageTop = $(window).scrollTop();
      var pageBottom = pageTop + $(window).height();
      var elementTop = $(element).offset().top;
      var elementBottom = elementTop + $(element).height();

      if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
      } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
      }
    }
  };

  var Utils = new Utils();

  /* ===================================
          Scroll
  ====================================== */
  // $('.parallaxie').parallaxie();


  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 260) { // Set position from top to add class
      $('header').addClass('header-appear');
    } else {
      $('header').removeClass('header-appear');
    }



  });


  // Close leadership bios and cleanup effects when scroll away
  jQuery.fn.isFullyVisible = function() {

    var win = $(window);

    var viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft()
    };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();


    // divide by two so less scroll away needed
    var elemtHeight = this.height() / 2; // Get the full height of current element
    elemtHeight = Math.round(elemtHeight); // Round it to a whole number

    var bounds = this.offset(); // Coordinates of current element
    bounds.top = bounds.top + elemtHeight;
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

  };

  $(window).on('scroll', function() {

    if (!$('#leadership').top) return;
    if ($('#leadership').isFullyVisible()) {
      $('.slidingDiv').hide();
      $('.show_hide_bio').text('+');
      $('.team-image').removeClass('grayed');

    }
  });


  $('.progress-bar').each(function() {
    $(this).appear(function() {
      $(this).animate({
        width: $(this).attr('aria-valuenow') + '%'
      }, 3000);
    });
  });


  $('.count').each(function() {
    $(this).appear(function() {
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text()
      }, {
        duration: 3000,
        easing: 'swing',
        step: function(now) {
          $(this).text(Math.ceil(now));
        }
      });
    });
  });


  //scroll to appear
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 500)
      $('.scroll-top-arrow').fadeIn('slow');
    else
      $('.scroll-top-arrow').fadeOut('slow');
  });

  // fixing bottom nav to top on scrolliing
  var $fixednav = $('.bottom-nav');
  $(window).on('scroll', function() {
    var $heightcalc = $(window).height() - $fixednav.height() - 10;
    if ($(this).scrollTop() > $heightcalc) {
      $fixednav.addClass('navbar-bottom-top');
    } else {
      $fixednav.removeClass('navbar-bottom-top');
    }
  });

  //Click event to scroll to top
  $(document).on('click', '.scroll-top-arrow', function() {
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    return false;
  });


  //scroll sections
  if ($('body').hasClass('intrective')) {
    $('.scroll').on('click', function(event) {
      event.preventDefault();
      $('html,body').animate({
        scrollTop: $(this.hash).offset().top
      }, 1200);
    });

  } else {

    $('.scroll').on('click', function(event) {
      event.preventDefault();
      $('html,body').animate({
        scrollTop: $(this.hash).offset().top - 60
      }, 1200);
    });

  }

  /* =====================================
         Parallax
  ====================================== */

  if ($(window).width() > 992) {

    $('.paroller, [data-paroller-factor]').paroller({
      factor: 0.22, // multiplier for scrolling speed and offset
      factorXs: 0.1, // multiplier for scrolling speed and offset
      type: 'foreground', // background, foreground
      direction: 'vertical', // vertical, horizontal
      transition: 'transform 0.11s ease' // CSS transition
    });

  }


  /* ===================================
       Side Menu
   ====================================== */
  if ($('#sidemenu_toggle').length) {
    $('#sidemenu_toggle').on('click', function() {
      $('.pushwrap').toggleClass('active');
      $('.side-menu').addClass('side-menu-active'), $('#close_side_menu').fadeIn(700);
    }), $('#close_side_menu').on('click', function() {
      $('.side-menu').removeClass('side-menu-active'), $(this).fadeOut(200), $('.pushwrap').removeClass('active');
    }), $('.side-nav .navbar-nav .nav-link').on('click', function() {
      $('.side-menu').removeClass('side-menu-active'), $('#close_side_menu').fadeOut(200), $('.pushwrap').removeClass('active');
    }), $('#btn_sideNavClose').on('click', function() {
      $('.side-menu').removeClass('side-menu-active'), $('#close_side_menu').fadeOut(200), $('.pushwrap').removeClass('active');
    });
  }

  if ($('.side-right-btn').length) {

    $('.side-right-btn').click(function() {
      $('.navbar.navbar-right').toggleClass('show');
    }),
      $('.navbar.navbar-right .navbar-nav .nav-link').click(function() {
        $('.navbar.navbar-right').toggleClass('show');
      });

  }



  if ($('.count_down').length) {
    $('.count_down').downCount({
      date: '03/3/2019 12:00:00',
      offset: +10
    });
  }




  /* =====================================
        Wow
   ======================================== */

  if ($(window).width() > 767) {
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: false,
      live: true
    });

    // toggled wow off
    // new WOW().init();
    wow.init();
  }



  // }
  // if ($(window).width() > 991) {
  // setTimeout(function () {
  //     animatedCursor();
  // }, 1000);
  // }




  /* ===================================
          Owl Carousel
   ====================================== */

  //About Slider

  $('#laptop-slide').owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    autoplay: true,
    autoplayTimeout: 3000,
    // mouseDrag:false,
    responsive: {
      1280: {
        items: 1,
      },
      600: {
        items: 1,
      },
      320: {
        items: 1,
      },
    }
  });

  //App Slider

  $('#app-slider').owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    autoplay: true,
    autoplayTimeout: 3000,
    // mouseDrag:false,
    responsive: {
      1280: {
        items: 1,
      },
      600: {
        items: 1,
      },
      320: {
        items: 1,
      },
    }
  });

  // Team Slider
  // $('*').css('border', '1px solid red');

  // position nav arrows

  // var teamSlider = $('#team-slider').children('.owl-stage-outer');
  // var desiredArrowPosition = teamSlider.height() / 2;
  // var teamArrows = $('#team-slider').find('.owl-nav');
  // debugger;
  // console.log(teamArrows)
  // $(teamArrows).css('background-color', 'purple');
  // teamArrows.css('top', desiredArrowPosition + 'px !important;');


  $('#team-slider').owlCarousel({
    items: 3,
    dots: false,
    // nav: false,
    nav: true,
    loop: true,
    navText: ['<img class=\'leader-left\' src=\'./assets/Carousel Arrow Left.png\'>', '<img class=\'leader-right\' src=\'./assets/Carousel Arrow Right.png\'>'],
    mouseDrag: false,
    // mouseDrag: true,
    responsive: {
      991: {
        items: 3,
      },
      767: {
        items: 2,
        mouseDrag: true,
      },
      320: {
        items: 1,
        mouseDrag: true
      },
    }
  });

  var teamSlider = $('#team-slider').children('.owl-stage-outer');
  var desiredArrowPosition = teamSlider.height() * .20;
  var teamArrows = $('#team-slider').find('.owl-nav');


  var variable = Math.floor(desiredArrowPosition) + 'px';


  $(teamArrows).css('top', variable);


  //price slider

  $('#price-slider').owlCarousel({
    items: 3,
    dots: false,
    nav: false,
    responsive: {
      991: {
        items: 3,
      },
      767: {
        items: 2,
      },
      320: {
        items: 1,
      },
    }
  });

  $('#team-three-slider').owlCarousel({
    items: 4,
    dots: false,
    nav: false,
    responsive: {
      991: {
        items: 4,
      },
      767: {
        items: 2,
      },
      320: {
        items: 1,
      },
    }
  });

  //testimonial slider

  $('#testimonial_slider').owlCarousel({
    items: 1,
    dots: true,
    autoplay: 8500,
    loop: true,
    nav: false,
  });




  setTimeout(function() {
    $('#supergraphic-1').removeClass('super-move-1');
  }, 10000);
  setTimeout(function() {
    $('#supergraphic-2').addClass('super-move-2');
  }, 6000);


  function resetAnim1() {
    $('#supergraphic-1').removeClass('super-move-1');
    void $('supergraphic').offsetWidth;

    setTimeout(function() {
      $('#supergraphic-1').addClass('super-move-1');
    }, 4500);
  }

  function resetAnim2() {
    $('#supergraphic-2').removeClass('super-move-2');
    void $('supergraphic').offsetWidth;

    setTimeout(function() {
      $('#supergraphic-2').addClass('super-move-2');
    }, 4500);
  }

  function resetAnim3() {
    $('#supergraphic-3').removeClass('super-move-3');
    void $('supergraphic').offsetWidth;

    setTimeout(function() {
      $('#supergraphic-3').addClass('super-move-3');
    }, 4500);
  }


  // resetAnim1();

  $('#single-slider').owlCarousel({
    onTranslated: function(me) {
      $(me.target).find('.owl-item.active [data-src]:not(.loaded)').each(function(i, v) {
        $(v).addClass('animate loaded fadeIn').css('background-image', 'url(' + $(v).attr('data-src') + ')');
      });
      $('.owl-item').removeClass('owl-animated-out');
      $('.owl-item').removeClass('fadeOut');
      $('.owl-item').removeClass('animated');

      if (me.item.index === 0) {
        resetAnim2();

      }
      if (me.item.index === 1) {
        resetAnim3();
      }
      if (me.item.index === 2) {
        resetAnim1();

      }



    },
    items: 1,
    lazyLoad: true,
    // lazyContent:true,
    nav: false,
    loop: false,
    rewind: true,
    mouseDrag: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    responsiveRefreshRate: 10,
    autoplayHoverPause: false,
    slideSpeed: 1000,
    autoplay: 6550,
    // autoplay: false,
    autoplayTimeout: 7000,
  });

  //team two slider

  $('#team-slider-two').owlCarousel({
    items: 1,
    nav: false,
    loop: true,
    dots: false,
    responsive: {
      991: {
        items: 2,
        autoplayHoverPause: true,
        autoplay: true,
        autoplayTimeout: 3000,
      },
      320: {
        items: 1,
      },
    }

  });


  //Contact Us
  $('#submit_btn').click(function(e) {
    e.preventDefault();
    //disable submit button on click
    $('#submit_btn').attr('disabled', 'disabled');
    $('#submit_btn span').text('Sending');
    $('#submit_btn i').removeClass('d-none');

    var user_name = $('input[name=first_name]').val() + ' ' + $('input[name=last_name]').val();
    var user_email = $('input[name=email]').val();
    var user_phone = $('input[name=phone]').val();
    var user_message = $('textarea[name=message]').val();

    //simple validation at client's end
    var post_data, output;
    var proceed = true;
    if (user_name === '') {
      proceed = false;
    }
    if (user_email === '') {
      proceed = false;
    }
    // if (user_phone == "") {
    //proceed = false;
    // }

    if (user_message === '') {
      proceed = false;
    }
    //everything looks good! proceed...
    if (proceed) {

      //data to be sent to server
      post_data = {
        'userName': user_name,
        'userEmail': user_email,
        'userPhone': user_phone,
        'userMessage': user_message
      };

      //Ajax post data to server

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: 'https://formcarry.com/s/t0K_Wy8JUH2',
        data: post_data,
        success: function(response) {
          if (response.status === 'success') {
            output = '<div class="alert-success" style="padding:10px; margin-bottom:30px;">Thank you, we\'ve received your submission.</div>';
            $('#result').hide().html(output).slideDown();
            //reset values in all input fields
            $('.contact-form input').val('');
            $('.contact-form textarea').val('');


          } else {
            alert('An error occured.');

            output = '<div class="alert-danger" style="padding:10px; margin-bottom:30px;">Something went wrong</div>';
            $('#result').hide().html(output).slideDown();

          }
        }
      });

      $('#submit_btn').removeAttr('disabled');
      $('#submit_btn span').text('Contact Now');
      $('#submit_btn i').addClass('d-none');

    } else {
      output = '<div class="alert-danger" style="padding:10px; margin-bottom:30px;">Please provide the missing fields.</div>';
      $('#result').hide().html(output).slideDown();

      // enable submit button on action done
      $('#submit_btn').removeAttr('disabled');
      $('#submit_btn span').text('Contact Now');
      $('#submit_btn i').addClass('d-none');
    }

  });



  // leadership


  // default states
  $('.slidingDiv').hide();
  $('.show_hide_bio').text('+');

  $('.show_hide_bio').click(function(e) {
    $('.team-image').removeClass('grayed');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var that = $(this);

    // MINIMIZE DOUBLE CLICK BEHAVIOR WITH TIMEOUT
    setTimeout(function() {
      var currentBox = '#' + that.parent().parent().attr('id');


      // either opening or closing
      $('.team-box').not(currentBox).children('.leadership-bio-box').children('.slidingDiv').slideUp();
      console.log(currentBox);
      $(currentBox).children('.team-image').removeClass('grayed');
      $('.team-box').not(currentBox).children('.team-image').addClass('grayed');
      // debugger;
      setTimeout(function() {
        $('.team-box').not(currentBox).children('.leadership-bio-box').children('.show_hide_bio').text('+');
      }, 550);


      $('.slidingDiv:visible').siblings().text(' ');

      if (that.siblings().is(':visible')) {
        $('.team-box').not(currentBox).children('.team-image').removeClass('grayed');
        setTimeout(function() {
          $(that).text('+');
          $(currentBox).children('.team-image').removeClass('grayed');
        }, 550);
      } else {
        that.text(' ');
      }

      that.next('.slidingDiv').slideToggle();
    }, 200);

  });

  $(document).click(function(e) {
    // e.stopPropagation();
    if ($('.slidingDiv').is(':visible')) {
      // console.log('fired closer')
      $('.team-image').removeClass('grayed');
      $('.slidingDiv:visible').each(function() {
        $(this).slideUp();
        var self = $(this);
        if (self.siblings().text(' ')) {
          setTimeout(function() {
            self.siblings().text('+');
          }, 550);
        }
      });
    }
  });

});
